import React from 'react'
import Game from '../Game/Game'
import Score from '../Score/Score'

const HomePage = ({setHideModal}) => {
  return (
    <>
    <div className='bg-gradient-to-b from-HomeRadialGradientStart to-HomeRadialGradientEnd h-screen overflow-hidden'>
        <Score/>
        <Game/>
        <div className='flex justify-content-center mt-6'>
        <button onClick={()=>{
            setHideModal(true)
        }} className=' mx-auto border-white border-2 border-solid rounded px-9 py-1 text-white tracking-theWidest'>
          RULES
        </button>
        </div>
    </div>
    </>
  )
}

export default HomePage